import axios from "axios";

export const patientMatchingRequest = async (params: {
  ciam_token: string;
  offset?: number;
}): Promise<any> => {
  const { ciam_token, offset } = params;
  const { data } = await axios.post("/api/v2/ciam_patient_matching", {
    ciam_token,
    offset
  },{
    headers: {
        'Content-Type': 'application/json'
    }
});

  return data;
};
